export const isDeviceIPRemote = (deviceIP) =>
	deviceIP && deviceIP !== "/" && !deviceIP.includes("localhost") && !deviceIP.includes("0.0.0.0");
